import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import LoadingSpinner from '../components/ui/LoadingSpinner';

const Home = React.lazy(() => import('../pages/Home'));
const Profile = React.lazy(() => import('../pages/Profile'));
const Listings = React.lazy(() => import('../pages/Listings'));
const ProductDetail = React.lazy(() => import('../pages/ProductDetail'));
const Requests = React.lazy(() => import('../pages/Requests'));
const TermsOfUse = React.lazy(() => import('../pages/TermsOfUse'));
const PrivacyPolicy = React.lazy(() => import('../pages/PrivacyPolicy'));
const CookiePolicy = React.lazy(() => import('../pages/CookiePolicy'));
const CommunityGuidelines = React.lazy(() => import('../pages/CommunityGuidelines'));
const ContactSupport = React.lazy(() => import('../pages/ContactSupport'));
const SafetyTrust = React.lazy(() => import('../pages/SafetyTrust'));
const HelpCentre = React.lazy(() => import('../pages/HelpCentre'));
const OurStory = React.lazy(() => import('../pages/OurStory'));
const PartnershipsPage = React.lazy(() => import('../pages/PartnershipsPage'));
const HowItWorks = React.lazy(() => import('../pages/HowItWorks'));
const ImageSearch = React.lazy(() => import('../pages/ImageSearch'));
const Bookmarks = React.lazy(() => import('../pages/BaoBookmarks'));
const Blog = React.lazy(() => import('../pages/BaoBlog'));
const BlogArticle = React.lazy(() => import('../pages/BaoBlogArticle'));

const SuspenseWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Suspense fallback={<div className="flex justify-center items-center min-h-screen"><LoadingSpinner size="lg" color="orange" /></div>}>
    {children}
  </Suspense>
);

export const homeRoutes = (
  <>
    <Route path="/" element={<SuspenseWrapper><Home /></SuspenseWrapper>} />
    <Route path="/profile" element={<SuspenseWrapper><Profile /></SuspenseWrapper>} />
    <Route path="/listings" element={<SuspenseWrapper><Listings /></SuspenseWrapper>} />
    <Route path="/product/:slug" element={<SuspenseWrapper><ProductDetail /></SuspenseWrapper>} />
    <Route path="/requests" element={<SuspenseWrapper><Requests /></SuspenseWrapper>} />
    <Route path="/requests/:id" element={<SuspenseWrapper><Requests /></SuspenseWrapper>} />
    <Route path="/terms" element={<SuspenseWrapper><TermsOfUse /></SuspenseWrapper>} />
    <Route path="/privacy" element={<SuspenseWrapper><PrivacyPolicy /></SuspenseWrapper>} />
    <Route path="/cookie-policy" element={<SuspenseWrapper><CookiePolicy /></SuspenseWrapper>} />
    <Route path="/community-guidelines" element={<SuspenseWrapper><CommunityGuidelines /></SuspenseWrapper>} />
    <Route path="/contact-support" element={<SuspenseWrapper><ContactSupport /></SuspenseWrapper>} />
    <Route path="/safety-trust" element={<SuspenseWrapper><SafetyTrust /></SuspenseWrapper>} />
    <Route path="/help-center" element={<SuspenseWrapper><HelpCentre /></SuspenseWrapper>} />
    <Route path="/partnerships" element={<SuspenseWrapper><PartnershipsPage /></SuspenseWrapper>} />
    <Route path="/how-it-works" element={<SuspenseWrapper><HowItWorks /></SuspenseWrapper>} />
    <Route path="/our-story" element={<SuspenseWrapper><OurStory /></SuspenseWrapper>} />
    <Route path="/image-search" element={<SuspenseWrapper><ImageSearch /></SuspenseWrapper>} />
    <Route path="/blog" element={<SuspenseWrapper><Blog /></SuspenseWrapper>} />
    <Route path="/blog/:slug" element={<SuspenseWrapper><BlogArticle /></SuspenseWrapper>} />
  </>
);
